var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04507 4.58166C3.07656 4.272 2.95795 3.96654 2.72701 3.75869L0.375677 0.924495V0.501465H7.67951L13.3248 12.8827L18.2878 0.501465H25.2505V0.924495L23.2393 2.8528C23.0661 2.98506 22.98 3.20235 23.0157 3.41754V17.5864C22.98 17.8006 23.0661 18.0179 23.2393 18.1501L25.2033 20.0784V20.5015H15.3235V20.0784L17.3588 18.1029C17.5583 17.9034 17.5583 17.8447 17.5583 17.5392V6.08694L11.9014 20.4553H11.1372L4.55035 6.08694V15.7169C4.49576 16.1211 4.63013 16.5294 4.9146 16.8212L7.5609 20.0312V20.4553H0.0576172V20.0312L2.70392 16.8212C2.98734 16.5283 3.1133 16.1179 3.04507 15.7169V4.58166Z",
    fill: "#F5FCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.22c3b24a.svg";
export { ForwardRef as ReactComponent };